// components/About.jsx
import React, { useEffect, useRef } from 'react';
import TransitionLink from './TransitionLink';
import { useLanguage } from '../context/LanguageContext';
import { useTranslation } from '../translations/translations';

const About = () => {
    const { language } = useLanguage();
    const t = useTranslation(language);
    const sectionRef = useRef(null);
    const itemsRef = useRef([]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        itemsRef.current.forEach((item) => {
            if (item) observer.observe(item);
        });

        return () => {
            observer.disconnect();
        };
    }, []);

    return (
        <section
            ref={sectionRef}
            id="about"
            className="w-full bg-white py-24 pt-32 transition-opacity duration-700 opacity-0 rounded-t-[40px]"
        >
            <div className="container mx-auto px-8 md:px-16">
                <div className="max-w-5xl">
                    <p
                        ref={(el) => (itemsRef.current[1] = el)}
                        className="text-2xl md:text-3xl text-gray-800 leading-tight opacity-0 transform translate-y-10 transition-all duration-700 delay-100 text-left font-light tracking-tight"
                        style={{ fontFamily: "'Space Grotesk', 'Archivo', sans-serif" }}
                    >
                        {t('aboutIntro')}
                    </p>

                    <div
                        ref={(el) => (itemsRef.current[2] = el)}
                        className="mt-10 opacity-0 transform translate-y-10 transition-all duration-700 delay-200"
                    >
                        <TransitionLink
                            to="/about"
                            className="header-nav-link relative inline-flex items-center text-black font-medium group overflow-hidden"
                            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                        >
                            <span className="relative z-10 inline-flex items-center transition-transform duration-500 group-hover:-translate-y-full">
                                {t('readMore')}
                                <span className="ml-2 transition-transform duration-300 group-hover:translate-x-1">→</span>
                            </span>
                            <span className="absolute left-0 top-full z-0 inline-flex items-center text-black transition-transform duration-500 group-hover:-translate-y-full">
                                {t('readMore')}
                                <span className="ml-2 translate-x-3">→</span>
                            </span>
                            <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-black transition-all duration-500 ease-out group-hover:w-full"></span>
                        </TransitionLink>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default About;